import { useIonModal } from '@ionic/react'
import { AnimatePresence, motion } from 'framer-motion'

import { UserListCard, UserListCardSkeleton } from '@apps-common/apps/portal/pages/units/pages/manage/pages/users/components'
import { SystemUserModifyModal } from '@apps-common/apps/portal/pages/units/pages/manage/pages/users/modals/system-user-modify-modal'
import { NoResultsAddCard } from '@apps-common/components/common'
import { motionFadeIn } from '@apps-common/config/motion-variants'
import { UNIT_STATUS_CANCELLED } from '@apps-common/config/unit-filter'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IUnitNamedUserCompleteModel } from '@apps-common/types/portal/users'

interface IProps {
  status: string
  unitId: string
  ipAddress: string
  users: IUnitNamedUserCompleteModel[]
  loading: boolean
}

export const SystemNamedUsers: React.FC<IProps> = ({ status, unitId, ipAddress, users, loading }) => {
  const [present, dismiss] = useIonModal(SystemUserModifyModal, {
    componentProps: {
      unit: {
        unitId,
        ipAddress
      }
    },
    onDismiss: (data: string, role: string) => dismiss(data, role),
    enableBackdropDismiss: true
  })

  return (
    <div className='max-w-full sm:max-w-[1000px]'>
      <div className='grid sm:grid-cols-2 gap-[15px]'>
        <AnimatePresence mode='popLayout'>
          {loading &&
            Array.from(Array(4).keys()).map((u, i) => (
              <motion.div key={`unit-system-named-user-${i}`} {...motionFadeIn(0.25)}>
                <UserListCardSkeleton />
              </motion.div>
            ))}
          {!loading && users && users.length === 0 && (
            <motion.div key='no-system-user-create-button' {...motionFadeIn(0.25)}>
              <NoResultsAddCard
                message='Add a new system user.'
                disabled={loading || status === UNIT_STATUS_CANCELLED.value}
                callback={() =>
                  present({
                    enterAnimation: modalSlideUpEnterAnimation,
                    leaveAnimation: modalSlideUpLeaveAnimation
                  })
                }
              />
            </motion.div>
          )}
          {!loading &&
            users &&
            users.length > 0 &&
            users?.map((u, i) => (
              <motion.div key={`unit-system-named-user-${u.unitNamedUserId}`} {...motionFadeIn(0.25)}>
                <UserListCard
                  index={i}
                  type='system'
                  unitId={unitId}
                  ipAddress={ipAddress}
                  userId={u.unitNamedUserId}
                  profileImage={u.profileImage}
                  name={`${u.firstName} ${u.lastName}`}
                  zone={u.zone}
                  partition={u.partition}
                />
              </motion.div>
            ))}
        </AnimatePresence>
      </div>
    </div>
  )
}
